import {
  ApplicationConfig,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { appRoutes } from './app.routes';
import { injectCssVariables } from '@snake/shared';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // 'computed' puts the URL back when a guard cancels a back-button navigation
    // (e.g. "Leave room?" → Cancel), instead of leaving history out of step.
    provideRouter(
      appRoutes,
      withRouterConfig({ canceledNavigationResolution: 'computed' })
    ),
    provideAppInitializer(injectCssVariables()),
  ],
};
